import { TextProps } from '@features/powerpoint';
import { theme } from '../domain/theme';

export const buildHeaderText = (
  text: string,
  active: boolean,
  options?: TextProps['options']
): TextProps => ({
  text: text.toUpperCase(),
  options: {
    fontSize: 9,
    color: active ? theme.colors.inmarketGreen : theme.colors.white,
    charSpacing: theme.charSpacing.loose,
    h: 0.25,
    w: 1.26,
    x: 3.64,
    y: 0.28,
    ...options,
  },
});

export type TabDefinition = {
  label: string;
  id: string;
  options?: TextProps['options'];
};
